export type ReplaySpeed = 'slow' | 'normal' | 'fast'

export function replayTiming(speed: ReplaySpeed, putt: boolean) {
  if (speed === 'slow') return { flightMs: putt ? 8_000 : 15_000, landingPauseMs: 3_000 }
  if (speed === 'normal') return { flightMs: putt ? 2_000 : 4_000, landingPauseMs: 1_000 }
  return { flightMs: putt ? 1_000 : 2_000, landingPauseMs: 500 }
}

export const replaySpeedLabel: Record<ReplaySpeed, string> = {
  slow: 'Slow (18 s; putts 11 s)', normal: 'Normal (5 s; putts 3 s)', fast: 'Fast (2.5 s; putts 1.5 s)',
}

export function replayTravelProgress(rawProgress:number){
  const raw=Math.max(0,Math.min(1,rawProgress))
  const smooth=raw*raw*(3-2*raw)
  // Mostly uniform travel, with only a gentle ease away from the start and
  // into the landing. This keeps the first few seconds visually meaningful.
  return raw*.88+smooth*.12
}
